import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _objectSpread from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/* eslint-disable no-shadow */
import Vue from 'vue';
import Vuex from 'vuex';
import MagicService from '@/service/magic';
import { now } from '@vip-activity/business';
import TicketService from '../service/ticket';
Vue.use(Vuex);
var state = {
  hasTickets: {},
  buyList: {},
  now: Date.now(),
  remainNum: 0,
  selectPayInfo: null
};
var mutations = {
  setState: function setState(state, payload) {
    state[payload.state] = payload.value;
  }
};
var actions = {
  // 刷新抽奖信息（抽奖次数）
  refreshLotteryInfo: function refreshLotteryInfo(_ref) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, res, _res$data$left_num, leftNum;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              _context.next = 3;
              return MagicService.getLotteryInfo();

            case 3:
              res = _context.sent;
              _res$data$left_num = res.data.left_num, leftNum = _res$data$left_num === void 0 ? 0 : _res$data$left_num;
              commit('setState', {
                state: 'remainNum',
                value: leftNum
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  getBuyList: function getBuyList(_ref2) {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var commit, params, list, data, obj, o;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              params = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : [];
              list = params.map(function (v) {
                return new Promise(function (resolve) {
                  TicketService.getBuyList(v).then(function (res) {
                    resolve({
                      name: v,
                      list: res.list || []
                    });
                  }).catch(function () {
                    resolve([]);
                  });
                });
              });
              _context2.next = 5;
              return Promise.all(list);

            case 5:
              data = _context2.sent;
              obj = data.reduce(function (total, cur) {
                return Object.assign(total, _defineProperty({}, cur.name, cur.list));
              }, {});
              o = _objectSpread(_objectSpread({}, state.buyList), obj);
              commit('setState', {
                state: 'buyList',
                value: o
              });

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  // 刷新用户的购票信息
  checkHasTicket: function checkHasTicket(_ref3) {
    var _arguments2 = arguments;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var commit, pidList, list, data, obj, o;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit;
              pidList = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : [];
              list = pidList.map(function (v) {
                return new Promise(function (resolve) {
                  TicketService.getHasZhiboTicket(v).then(function (res) {
                    resolve({
                      pid: v,
                      status: res.payStatus !== 0
                    });
                  }).catch(function () {
                    resolve(false);
                  });
                });
              });
              _context3.next = 5;
              return Promise.all(list);

            case 5:
              data = _context3.sent;
              obj = data.reduce(function (total, cur) {
                return Object.assign(total, _defineProperty({}, cur.pid, cur.status));
              }, {});
              o = _objectSpread(_objectSpread({}, state.hasTickets), obj);
              commit('setState', {
                state: 'hasTickets',
                value: o
              });

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  getNow: function getNow(_ref4) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var commit, time;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref4.commit;
              time = Date.now();
              _context4.prev = 2;
              _context4.next = 5;
              return now();

            case 5:
              time = _context4.sent;
              _context4.next = 11;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](2);
              console.log(_context4.t0);

            case 11:
              commit('setState', {
                state: 'now',
                value: time
              });

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 8]]);
    }))();
  },
  // 设置支付面包的购票信息
  setSelectPayInfo: function setSelectPayInfo(_ref5, info) {
    var commit = _ref5.commit;
    commit('setState', {
      state: 'selectPayInfo',
      value: info
    });
  }
};
var getters = {
  mySupportCount: function mySupportCount() {
    return function (id) {
      var list = state.buyList[id] || [];
      var total = 0;
      list.forEach(function (item) {
        total += item.iTicketNum;
      });
      return total;
    };
  }
};
export default new Vuex.Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});